import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-badge.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-toggle-icon-button, [toggle-icon-button]',
  templateUrl: './toggle-icon-button.component.html',
  styleUrls: ['./toggle-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleIconButtonComponent extends ButtonCoreComponent implements OnChanges {
  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'toggle-icon-button',
    'relative',
    'flex',
    'p-3xs',
    'corner-full',
    'border',

    'disabled:border-on-surface',
    'disabled:border-opacity-disabled',
    'disabled:icon-on-surface',
    'disabled:icon-opacity-disabled',
  ];

  ripple = false;

  @Input() icon: string;

  @HostBinding('attr.aria-pressed')
  ariaPressed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected) {
      this.ariaPressed = this.selected;
    }
  }
}
